import Model from './Model'
// import Avatar from './Avatar'

export default class VenueTag extends Model {
  resource() {
    return 'venue-tags'
  }
}
